export default __webpack_public_path__ + "static/media/LINE_spinner_light.d002e6e2.svg";